// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2nsUX","modalForm":"UpgradeEpcsModal_modalForm__26F_q","modalFooter":"UpgradeEpcsModal_modalFooter__2sNl7"};